import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { Mountain, Lock } from "lucide-react";

export default function AdminLogin() {
  const { admin, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (admin) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || "Giriş başarısız");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-[#0A1A10] sr-grain px-5">
      <div className="relative w-full max-w-md">
        <div className="text-center mb-8">
          <span className="inline-grid place-items-center h-14 w-14 rounded-2xl bg-[#1B4D2E] border border-[#D4AF37]/40 mb-4">
            <Mountain className="h-7 w-7 text-[#D4AF37]" />
          </span>
          <h1 className="font-serif-display text-3xl font-bold text-white">Saklı Rota CMS</h1>
          <p className="text-white/50 mt-2 text-sm">Yönetim paneline giriş yapın</p>
        </div>

        <form onSubmit={submit} data-testid="admin-login-form" className="rounded-3xl bg-white p-8 space-y-5">
          <label className="block">
            <span className="block text-sm font-medium text-[#1A251E] mb-2">E-posta</span>
            <input required type="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email-input" className="sr-input" placeholder="admin@saklirota.com" />
          </label>
          <label className="block">
            <span className="block text-sm font-medium text-[#1A251E] mb-2">Şifre</span>
            <input required type="password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password-input" className="sr-input" placeholder="••••••••" />
          </label>
          {error && <p data-testid="admin-login-error" className="text-sm text-red-600 bg-red-50 rounded-lg px-3 py-2">{error}</p>}
          <button disabled={loading} data-testid="admin-login-btn" className="w-full inline-flex items-center justify-center gap-2 px-6 py-4 rounded-full bg-[#0F2F1D] text-white font-semibold hover:bg-[#1B4D2E] transition-colors disabled:opacity-60">
            <Lock className="h-4 w-4" /> {loading ? "Giriş yapılıyor..." : "Giriş Yap"}
          </button>
        </form>
      </div>
    </div>
  );
}
